import React, { Component } from 'react';
import {
    Paper,
    Button,
    Avatar,
    CardHeader,
    Table,
    TableRow,
    TableHead,
    TableCell,
    TableBody,
    CircularProgress
} from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import { getOffSetTime, ROLE_CUSTOMER } from '../../utils/config/constants.js';
import * as actions from '../../actions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { validateNonEmpty } from '../../utils/validators/validateForm.js';
import { NotificationManager } from 'react-notifications';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import AddWalletMoney from '../Customer/AddWalletMoney.jsx';
class ConfirmedData extends Component {
    state = {
        selectedPackage: {},
        loaderButton: false,
        redirectBookingDashboard: false,
        redirectCardPayment: false,
        bookingId: '',
        showAddWalletOption: false
    };

    renderButton = () => {
        if (this.state.loaderButton) {
            return (
                <div className="text-center">
                    <CircularProgress />
                </div>
            );
        } else {
            return (
                <div className="text-center mt-3 mb-3">
                    {this.props.userData.role == ROLE_CUSTOMER && (
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={() => this.createBooking()}
                        >
                            <FormattedMessage
                                id="booking.book"
                                defaultMessage="Book"
                            />
                        </Button>
                    )}
                </div>
            );
        }
    };

    createBooking = () => {
        const { selectedPromoCode } = this.props;

        if (this.props.paymentType == 3 && this.props.packageItem != null) {
            if (this.props.userData.wallet < this.props.packageItem.price) {
                NotificationManager.error(
                    <FormattedMessage
                        id="walletBalanceLow"
                        defaultMessage="Your wallet balance is low, please recharge"
                    />
                );
                this.props.showAddFundOption();
            } else {
                if (
                    this.checkBookingData(
                        {
                            addressId: this.props.selectedAddress.key,
                            paymentType: this.props.paymentType,
                            bookingDate: this.props.bookingDate,
                            bookingTime: this.props.bookingTime.start,
                            packageItem: this.props.packageItem
                                ? this.props.packageItem.key
                                : null,
                            providerId: this.props.data.id,
                            serviceId: this.props.data.proServiceId,
                            providerAddressId: this.props.data.displayAddress
                                .id,
                            day: new Date().getDay(),
                            offset: new Date().getTimezoneOffset()
                        },
                        this.handleError
                    )
                ) {
                    this.setState({ loaderButton: true });
                    this.props.createBookingAction(
                        {
                            note: this.props.additionalNotes,
                            promoCode: {
                                code: selectedPromoCode.code,
                                id: selectedPromoCode.key
                            },
                            customerAddressId: this.props.selectedAddress.key,
                            paymentType: this.props.paymentType,
                            date: this.props.bookingDate,
                            time: getOffSetTime(this.props.bookingTime.start),
                            proPackageId: this.props.packageItem
                                ? [this.props.packageItem.key]
                                : [],
                            providerId: this.props.data.id,
                            proServiceId: this.props.data.proServiceId,
                            providerAddressId: this.props.data.displayAddress
                                .id,
                            day: new Date().getDay(),
                            offset: new Date().getTimezoneOffset()
                        },
                        this.onBookingDone
                    );
                }
            }
        } else {
            if (
                this.checkBookingData(
                    {
                        addressId: this.props.selectedAddress.key,
                        paymentType: this.props.paymentType,
                        bookingDate: this.props.bookingDate,
                        bookingTime: this.props.bookingTime.start,
                        packageItem: this.props.packageItem
                            ? this.props.packageItem.key
                            : null,
                        providerId: this.props.data.id,
                        serviceId: this.props.data.proServiceId,
                        providerAddressId: this.props.data.displayAddress.id
                    },
                    this.handleError
                )
            ) {
                this.setState({ loaderButton: true });
                this.props.createBookingAction(
                    {
                        note: this.props.additionalNotes,
                        promoCode: {
                            code: selectedPromoCode.code,
                            id: selectedPromoCode.key
                        },
                        customerAddressId: this.props.selectedAddress.key,
                        paymentType: this.props.paymentType,
                        date: this.props.bookingDate,
                        time: getOffSetTime(this.props.bookingTime.start),
                        proPackageId: this.props.packageItem
                            ? [this.props.packageItem.key]
                            : [],
                        providerId: this.props.data.id,
                        proServiceId: this.props.data.proServiceId,
                        providerAddressId: this.props.data.displayAddress.id
                    },
                    this.onBookingDone
                );
            }
        }
    };

    onBookingDone = (success, data) => {
        if (success) {
            NotificationManager.success(data.message, 'Booking Initiated');
            if (data.data.payment_type == 1) {
                this.setState({
                    loaderButton: false,
                    redirectBookingDashboard: true,
                    bookingId: data.data.key
                });
            } else if (data.data.payment_type == 2) {
                this.setState({
                    loaderButton: false,
                    redirectCardPayment: true,
                    bookingId: data.data.key
                });
            } else if (data.data.payment_type == 3) {
                this.setState({
                    loaderButton: false,
                    redirectBookingDashboard: true,
                    bookingId: data.data.key
                });
            } else if (data.data.payment_type == 4) {
                this.setState({
                    loaderButton: false,
                    redirectPayfastPayment: true,
                    bookingId: data.data.key
                });
            } else if (data.data.payment_type == 5) {
                this.setState({
                    loaderButton: false,
                    redirectPaypalPayment: true,
                    bookingId: data.data.key
                });
            }
        } else {
            this.setState({ loaderButton: false });
            NotificationManager.error(data.message, 'Error');
        }
    };
    checkBookingData = (
        {
            addressId,
            paymentType,
            bookingDate,
            bookingTime,
            packageItem,
            providerId,
            serviceId,
            providerAddressId
        },
        done
    ) => {
        let validation = true;
        if (!validateNonEmpty(addressId)) {
            validation = false;
            done('Customer Address is required');
        }
        if (!validateNonEmpty(paymentType)) {
            validation = false;
            done('Please Choose atleast one payment method');
        }
        if (!validateNonEmpty(bookingDate)) {
            validation = false;
            done('Select a Booking Date atleast');
        }
        if (!validateNonEmpty(bookingTime)) {
            validation = false;
            done('Select a date with Available time slot');
        }
        if (!validateNonEmpty(providerId)) {
            validation = false;
            done('Select provider profile to book a service');
        }
        if (!validateNonEmpty(providerAddressId)) {
            validation = false;
            done('Provider Address is empty');
        }
        if (packageItem) {
            if (!validateNonEmpty(packageItem)) {
                validation = false;
                done('Package is not selected');
            }
        }
        if (serviceId) {
            if (!validateNonEmpty(serviceId)) {
                validation = false;
                done('Select a service to book');
            }
        }
        return validation;
    };

    handleError = error => {
        if (error) {
            NotificationManager.error(error, 'Error');
        }
    };
    render() {
        const {
            data,
            selectedAddress,
            bookingTime,
            bookingDate,
            selectedPromoCode,
            additionalNotes,
            isService,
            packageItem,
            finalAmount
        } = this.props;
        if (this.state.redirectBookingDashboard) {
            this.props.history.push({
                pathname: `/user/booking/detail/${this.state.bookingId}`,
                bookingId: this.state.bookingId
            });
        }

        if (this.state.redirectCardPayment) {
            this.props.history.push({
                pathname: `/booking/payment/${this.state.bookingId}`
            });
            // return (
            //     <Redirect
            //         to={{
            //             pathname: `/booking/payment/${this.state.bookingId}`
            //         }}
            //     />
            // );
        }

        if (this.state.redirectPayfastPayment) {
            this.props.history.push({
                pathname: `/booking/payfastpayment/${this.state.bookingId}`
            });
            // return (
            //     <Redirect
            //         to={{
            //             pathname: `/booking/payfastpayment/${
            //                 this.state.bookingId
            //             }`
            //         }}
            //     />
            // );
        }
        return (
            <div className="col-md-12 main-panel confirm-book-side">
                <div>
                    <h4>
                        <b>
                            <FormattedMessage
                                id="booking.provider"
                                defaultMessage="Provider"
                            />
                        </b>
                        {data.proImage && (
                            <CardHeader
                                className="pl-0 pr-0"
                                avatar={<Avatar src={data.proImage.small} />}
                                title={data.businessName}
                                subheader={data.tagline}
                            />
                        )}
                    </h4>
                </div>

                {packageItem ? (
                    <div>
                        <h4>
                            <b>
                                <FormattedMessage
                                    id="booking.servicepackage"
                                    defaultMessage="Service Package"
                                />
                            </b>
                        </h4>
                        <div className="tz-db-table mb-4">
                            <Table className="bordered">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <FormattedMessage
                                                id="booking.name"
                                                defaultMessage="Name"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <FormattedMessage
                                                id="booking.price"
                                                defaultMessage="Price"
                                            />
                                        </TableCell>
                                        {finalAmount && (
                                            <TableCell>
                                                <FormattedMessage
                                                    id="booking.discountedprice"
                                                    defaultMessage="Discounted Price"
                                                />
                                            </TableCell>
                                        )}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            {packageItem.name
                                                ? packageItem.name
                                                : ''}
                                        </TableCell>
                                        <TableCell>
                                            {packageItem.price
                                                ? packageItem.price
                                                : ''}
                                        </TableCell>
                                        {finalAmount && (
                                            <TableCell>{finalAmount}</TableCell>
                                        )}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                ) : (
                    <div>
                        <h4>
                            <b>
                                <FormattedMessage
                                    id="booking.service"
                                    defaultMessage="Service"
                                />
                            </b>
                        </h4>
                        <div className="tz-db-table mb-4">
                            <Table className="bordered">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <FormattedMessage
                                                id="booking.name"
                                                defaultMessage="Name"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <FormattedMessage
                                                id="booking.price"
                                                defaultMessage="Price"
                                            />
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            {this.props.data.serviceName}
                                        </TableCell>
                                        <TableCell>
                                            {this.props.data.servicePrice}
                                            /
                                            <FormattedMessage
                                                id="hour"
                                                defaultMessage="hour"
                                            />
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                )}
                {bookingDate && (
                    <div>
                        <h4>
                            <b>
                                <FormattedMessage
                                    id="booking.date"
                                    defaultMessage="Date"
                                />
                            </b>
                            <p>{bookingDate}</p>
                        </h4>
                    </div>
                )}
                {bookingTime && (
                    <div>
                        <h4>
                            <b>
                                <FormattedMessage
                                    id="booking.time"
                                    defaultMessage="Time"
                                />
                            </b>
                            <p>{bookingTime.label}</p>
                        </h4>
                    </div>
                )}
                {selectedAddress && (
                    <div>
                        <h4>
                            <b>
                                <FormattedMessage
                                    id="booking.billingaddress"
                                    defaultMessage="Booking and Billing Address"
                                />
                            </b>
                        </h4>
                        <p>
                            <b> {selectedAddress.name}</b> <br />
                            <b>
                                <FormattedMessage
                                    id="booking.phone"
                                    defaultMessage="Phone"
                                />
                                :
                            </b>
                            {selectedAddress.phone} <br />
                            <b>
                                <FormattedMessage
                                    id="booking.email"
                                    defaultMessage="Email"
                                />
                                :
                            </b>
                            {selectedAddress.email} <br />
                            <b>
                                <FormattedMessage
                                    id="booking.address"
                                    defaultMessage="Address"
                                />
                                :
                            </b>
                            {selectedAddress.address_line1}
                        </p>
                    </div>
                )}

                {selectedPromoCode && (
                    <div>
                        <h4>
                            <b>
                                <FormattedMessage
                                    id="booking.promo"
                                    defaultMessage="Promo Code"
                                />
                            </b>
                        </h4>
                        <Button variant="outlined" color="primary">
                            {selectedPromoCode.code}
                        </Button>
                    </div>
                )}

                {this.state.redirectWalletPayment && <AddWalletMoney />}

                {additionalNotes && (
                    <div>
                        <h4>
                            <b>
                                <FormattedMessage
                                    id="booking.notes"
                                    defaultMessage="Additional Notes"
                                />
                            </b>
                        </h4>
                        <p>{additionalNotes}</p>
                    </div>
                )}

                <div className=" mb-2">{this.renderButton()}</div>
            </div>
        );
    }
}

const composedComponent = compose(withTheme(), connect(null, actions));

export default composedComponent(withUser(withRouter(ConfirmedData)));



// WEBPACK FOOTER //
// ./src/components/Booking/ConfirmedData.jsx